module.exports = __webpack_public_path__ + "img/bank-of-china-img.6930891a.png";